/*
 * @Author: Teemo Ding
 * @Date: 2022-02-16 15:10:11
 * @LastEditTime: 2022-05-17 13:26:33
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/CommunicationChannel/index.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { calculateCommunication } from '../../tool';
import { communicationChannelColum } from '../config';
import css from '../css.module.less';
import { IParams } from '../index';

const CommunicationChannel = ({ usedInSalesChannels }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { gateway, channelType } = useParams() as IParams;
  const renderText = calculateCommunication(gateway, channelType, {
    getI18n,
  }).channelType;
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      rightPart={''}
      title={getI18n('storeCommunicationSetting.detail.communicationChannel')}>
      <h3 className={css.topTitle}>
        {getI18n('storeCommunicationSetting.detail.communicationChannel')}
      </h3>
      <p>{renderText}</p>
      <h3 className={css.title}>
        {getI18n('storeCommunicationSetting.detail.usedinSalesChannels')}
      </h3>
      <SizeFittingTable
        id={'CommunicationChannel'}
        rowKey={(record) => record?.paymentMethod?.uuid}
        bordered
        // rowClassName={css.row}
        // className={css.table}
        pagination={false}
        columns={communicationChannelColum({ getI18n })}
        dataSource={usedInSalesChannels}
      />
    </SectionWrapper>
  );
};

export default CommunicationChannel;
